import { render, staticRenderFns } from "./AssessmentGrade.vue?vue&type=template&id=6c4e66fe&"
import script from "./AssessmentGrade.vue?vue&type=script&lang=js&"
export * from "./AssessmentGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports